// Startseite der Gespräche: der Verlauf (History). Live Calls, Qualität und das einzelne Gespräch hängen in `pages/Gespraeche.tsx`.
import { Verlauf } from "./Verlauf";

export function GespraecheStart() {
  return <Verlauf />;
}
